import { addDays, getDay, isAfter, isValid, parse, startOfDay } from 'date-fns';
import { RuleProps } from '../../../../types/application';
import { isEnglish } from 'features/applicationPage/helpers';

export const IMPORT_DETAILS = 'import-details';
export const TITLE_DETAILS = 'title-details';
export const SUBTITLES_DETAILS = 'subtitles-details';
export const REMARKS = 'remarks';
export const CA_CLASSIFICATION_DETAILS = 'ca-classification-details';

const SUBMISSION_OF_CO_CLASSIFIED_FILMS_FOR_EXHIBITION = [
    {
        sectionID: IMPORT_DETAILS,
        sectionName: 'Format Details',
        fieldList: [
            {
                id: 'format',
                label: 'Format',
                type: 'dropdown',
                apiID: 'IMDA-IRIS-Work-Films-Format',
                hasLabelInfo: true,
                rule: {
                    required: true
                }
            },
            {
                id: 'type',
                label: 'Type',
                type: 'dropdown',
                // apiID: 'IMDA-IRIS-Work-Films-Type',
                options: [{ optID: 'FTR', optLabel: 'FEATURE' }],
                rule: {
                    baseIds: [`${TITLE_DETAILS}-is-existing-title`],
                    required: true,
                    disabled: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-is-existing-title`] === 'Yes');
                        return result;
                    },
                    setValue: ({ currentValue }: RuleProps) => {
                        const result = currentValue === '' ? 'FTR' : currentValue;
                        return result;
                    }
                }
            },
            {
                id: 'online-link',
                label: 'Online Link',
                type: 'url',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] === 'ONLNK');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] !== 'ONLNK');
                        return result;
                    }
                },
                labelNote:
                    'If you have multiple links, please enter one of the links in the mandatory field. Save all links in an editable file type (e.g. .doc, .docx, .xls, .txt or .rtf) and upload it in the “Attachment upload” section.'
            },
            {
                id: 'id-username',
                label: 'ID/Username',
                type: 'text',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] !== 'ONLNK');
                        return result;
                    }
                }
            },
            {
                id: 'password',
                label: 'Password',
                type: 'text',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] !== 'ONLNK');
                        return result;
                    }
                }
            },
            // {
            //     id: 'dcp-ready-date',
            //     label: 'DCP Ready Date',
            //     type: 'date',
            //     rule: {
            //         baseIds: [`${IMPORT_DETAILS}-format`],
            //         required: ({ baseValues }: RuleProps) => {
            //             const result = Boolean(
            //                 baseValues &&
            //                     (baseValues[`${IMPORT_DETAILS}-format`] === 'DCP' ||
            //                         baseValues[`${IMPORT_DETAILS}-format`] === 'DCP3D' ||
            //                         baseValues[`${IMPORT_DETAILS}-format`] === 'EDCP')
            //             );
            //             return result;
            //         },
            //         hidden: ({ baseValues }: RuleProps) => {
            //             const result = Boolean(
            //                 baseValues &&
            //                     !(
            //                         baseValues[`${IMPORT_DETAILS}-format`] === 'DCP' ||
            //                         baseValues[`${IMPORT_DETAILS}-format`] === 'DCP3D' ||
            //                         baseValues[`${IMPORT_DETAILS}-format`] === 'EDCP'
            //                     )
            //             );
            //             return result;
            //         },
            //         dateLimit: () => {
            //             return { minDate: new Date() };
            //         },
            //         customValidate: ({ currentValue }: RuleProps) => {
            //             const currentDate = new Date();
            //             const formatter = new Intl.DateTimeFormat('en', {
            //                 weekday: 'short',
            //                 month: 'short',
            //                 day: '2-digit',
            //                 year: 'numeric'
            //             });
            //             const formattedDate = formatter.format(currentDate);

            //             if (currentValue && new Date(currentValue as string) < new Date(formattedDate)) {
            //                 return 'Must select current date or future date';
            //             }
            //         }
            //     }
            // },
            {
                id: 'kdm-required',
                label: 'Is Key Delivery Message (KDM) required?',
                type: 'radio',
                options: [
                    {
                        optID: 'Yes',
                        optLabel: 'Yes'
                    },
                    {
                        optID: 'No',
                        optLabel: 'No'
                    }
                ],
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${IMPORT_DETAILS}-format`] === 'DCP' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'DCP3D' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'EDCP')
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            !(
                                baseValues[`${IMPORT_DETAILS}-format`] === 'DCP' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'DCP3D' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'EDCP'
                            )
                        );
                        return result;
                    }
                }
            },
            {
                id: 'other-format',
                label: 'Other Format',
                type: 'text',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] === 'OTH');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] !== 'OTH');
                        return result;
                    },
                    customValidate: ({ currentValue }: RuleProps) => {
                        if (!isEnglish(currentValue as string)) {
                            return 'Only English inputs are accepted';
                        }
                    }
                }
            },
            {
                id: 'no-of-pieces',
                label: 'No. of Pieces',
                type: 'number',
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${IMPORT_DETAILS}-format`] !== 'ONLNK' ||
                                baseValues[`${IMPORT_DETAILS}-format`] !== 'EDCP' ||
                                baseValues[`${IMPORT_DETAILS}-format`] !== 'OTH' ||
                                baseValues[`${IMPORT_DETAILS}-format`] !== 'TPOFD')
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${IMPORT_DETAILS}-format`] === 'ONLNK' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'EDCP' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'OTH' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'TPOFD' ||
                                !baseValues[`${IMPORT_DETAILS}-format`])
                        );
                        return result;
                    },
                    customValidate: ({ currentValue }: RuleProps) => {
                        if (Number(currentValue) <= 0) {
                            return 'Must be greater than zero';
                        }
                    }
                }
            },
            {
                id: 'dateCombo',
                label: 'Preferred Date of Media Submission',
                type: 'dateRadio',
                span: 12,
                rule: {
                    baseIds: [`${IMPORT_DETAILS}-format`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${IMPORT_DETAILS}-format`] !== 'ONLNK' ||
                                baseValues[`${IMPORT_DETAILS}-format`] !== 'EDCP' ||
                                baseValues[`${IMPORT_DETAILS}-format`] !== 'OTH' ||
                                baseValues[`${IMPORT_DETAILS}-format`] !== 'TPOFD' ||
                                !baseValues[`${IMPORT_DETAILS}-format`])
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${IMPORT_DETAILS}-format`] === 'ONLNK' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'EDCP' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'OTH' ||
                                baseValues[`${IMPORT_DETAILS}-format`] === 'TPOFD' ||
                                !baseValues[`${IMPORT_DETAILS}-format`])
                        );
                        return result;
                    }
                },
                preField: {
                    id: 'radio-day',
                    label: ' ',
                    type: 'radio',
                    // defaultValue: 'AM',
                    options: [
                        {
                            optID: 'AM',
                            optLabel: 'AM'
                        },
                        {
                            optID: 'PM',
                            optLabel: 'PM'
                        }
                        // {
                        //     optID: 'Full Day',
                        //     optLabel: 'Full Day'
                        // }
                    ],
                    labelNote: "Media submission appointment subject to IMDA's confirmation."
                },
                mainField: {
                    id: 'main',
                    type: 'date2',
                    rule: {
                        baseIds: [`${IMPORT_DETAILS}-format`],
                        required: ({ baseValues }: RuleProps) => {
                            const result = Boolean(baseValues && baseValues[`${IMPORT_DETAILS}-format`] !== 'ONLNK');
                            return result;
                        },
                        dateLimit: () => {
                            const currentDate = new Date();
                            return { minDate: new Date(), maxDate: new Date().setDate(currentDate.getDate() + 30) };
                        },
                        customValidate: ({ currentValue }: RuleProps) => {
                            if (!currentValue) return;

                            const selectedDate = parse(currentValue as string, 'yyyy-MM-dd', new Date());
                            if (!isValid(selectedDate)) return 'Invalid Date';

                            const today = startOfDay(new Date());
                            const maxDate = addDays(today, 30);

                            if (selectedDate < today) {
                                return 'Must select current date or future date';
                            }

                            if (isAfter(selectedDate, maxDate)) {
                                return 'Date must not be more than 30 days from today';
                            }

                            const day = getDay(selectedDate);
                            if (day === 0 || day === 6) {
                                return 'Weekend dates are not allowed';
                            }

                            return true;
                        },
                        disabledWeekend: true
                    }
                }
            }
        ]
    },
    {
        sectionID: TITLE_DETAILS,
        sectionName: 'Title Details',
        fieldList: [
            {
                id: 'language-group',
                apiID: 'LanguageGroup',
                label: 'Language Group',
                type: 'dropdown',
                rule: {
                    baseIds: [`${TITLE_DETAILS}-is-existing-title`],
                    required: true,
                    disabled: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-is-existing-title`] === 'Yes');
                        return result;
                    }
                }
            },
            {
                id: 'sub-language-group',
                apiID: 'SubLanguageGroup',
                label: 'Sub-Language Group',
                type: 'dropdown',
                rule: {
                    baseIds: [`${TITLE_DETAILS}-language-group`, `${TITLE_DETAILS}-is-existing-title`],
                    optionGroup: `${TITLE_DETAILS}-language-group`,
                    required: true,
                    disabled: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-is-existing-title`] === 'Yes');
                        return result;
                    }
                }
            },
            {
                id: 'other-language-desc',
                label: 'Other Language',
                type: 'text',
                placeholder: 'Enter language name (e.g., English, Chinese, Malay)',
                rule: {
                    baseIds: [`${TITLE_DETAILS}-language-group`, `${TITLE_DETAILS}-sub-language-group`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            (baseValues[`${TITLE_DETAILS}-language-group`] === 'OTH' ||
                                baseValues[`${TITLE_DETAILS}-sub-language-group`] === 'OTH' ||
                                baseValues[`${TITLE_DETAILS}-sub-language-group`] === 'NA')
                        );
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues &&
                            !(
                                baseValues[`${TITLE_DETAILS}-language-group`] === 'OTH' ||
                                baseValues[`${TITLE_DETAILS}-sub-language-group`] === 'OTH' ||
                                baseValues[`${TITLE_DETAILS}-sub-language-group`] === 'NA'
                            )
                        );
                        return result;
                    }
                }
            },
            {
                id: 'is-existing-title',
                label: '',
                type: 'text',
                rule: { hidden: true }
            },
            {
                id: 'title',
                label: 'Title',
                type: 'text',
                rule: {
                    baseIds: [`${TITLE_DETAILS}-is-existing-title`],
                    required: true,
                    disabled: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-is-existing-title`] === 'Yes');
                        return result;
                    }
                }
            },
            {
                id: 'romaised-title',
                label: 'Romanised Title',
                type: 'text',
                rule: {
                    baseIds: [
                        `${TITLE_DETAILS}-language-group`,
                        `${TITLE_DETAILS}-sub-language-group`,
                        `${TITLE_DETAILS}-is-existing-title`
                    ],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-language-group`] !== 'EN');
                        return result;
                    },
                    disabled: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-is-existing-title`] === 'Yes');
                        return result;
                    },
                    customValidate: ({ baseValues, currentValue }: RuleProps) => {
                        if (!isEnglish(currentValue as string) && baseValues && baseValues[`${TITLE_DETAILS}-language-group`] !== 'EN') {
                            return 'Only English inputs are accepted';
                        }
                    }
                }
            },
            {
                id: 'also-known-as',
                label: 'Also Known As',
                type: 'text',
                rule: {
                    baseIds: [`${TITLE_DETAILS}-is-existing-title`],
                    disabled: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-is-existing-title`] === 'Yes');
                        return result;
                    }
                }
            },
            {
                id: 'director',
                label: 'Director',
                type: 'text',
                rule: {
                    baseIds: [`${TITLE_DETAILS}-is-existing-title`],
                    required: true,
                    disabled: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-is-existing-title`] === 'Yes');
                        return result;
                    }
                }
            },
            {
                id: 'running-time',
                label: 'Running Time (in minutes)',
                type: 'number',
                rule: { charLength: 6, required: true }
            },
            {
                id: 'submission-purpose',
                label: 'Purpose of Submission',
                type: 'dropdown',
                options: [
                    { optID: 'TR', optLabel: 'Theatrical Release' },
                    { optID: 'OTH', optLabel: 'Others' }
                ],
                rule: {
                    required: true
                }
            },
            {
                id: 'nature-of-event-activity',
                label: 'Nature or Name of Event/Activity',
                type: 'text',
                rule: {
                    baseIds: [`${TITLE_DETAILS}-submission-purpose`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-submission-purpose`] === 'OTH');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-submission-purpose`] !== 'OTH');
                        return result;
                    }
                }
            },
            {
                id: 'submission-extra-features',
                label: 'Does your submission include Extra Features?',
                type: 'radio',
                options: [
                    {
                        optID: 'Yes',
                        optLabel: 'Yes'
                    },
                    {
                        optID: 'No',
                        optLabel: 'No'
                    }
                ],
                rule: {
                    baseIds: [`${TITLE_DETAILS}-submission-purpose`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-submission-purpose`] === 'OTH');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-submission-purpose`] !== 'OTH');
                        return result;
                    }
                }
            },
            {
                id: 'classify-extra-features',
                label: 'Do you want to classify these Extra Features?',
                type: 'radio',
                options: [
                    {
                        optID: 'Yes',
                        optLabel: 'Yes'
                    },
                    {
                        optID: 'No',
                        optLabel: 'No'
                    }
                ],
                rule: {
                    baseIds: [`${TITLE_DETAILS}-submission-extra-features`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-submission-extra-features`] === 'Yes');
                        return result;
                    },
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${TITLE_DETAILS}-submission-extra-features`] !== 'Yes');
                        return result;
                    }
                }
            },
            {
                id: 'screening-date',
                label: 'Screening Date',
                type: 'table',
                rule: { required: true, single: true },
                subFields: [
                    {
                        id: 'from',
                        header: 'From',
                        type: 'date2',
                        rule: {
                            baseIds: [`${TITLE_DETAILS}-screening-date.0.to`],
                            required: true,
                            dateLimit: () => {
                                return { minDate: new Date() };
                            },
                            revalidate: [`${TITLE_DETAILS}-screening-date.0.to`],
                            customValidate: ({ currentValue, baseValues }: RuleProps) => {
                                if (!currentValue) return;

                                const selectedDate = parse(currentValue as string, 'yyyy-MM-dd', new Date());
                                if (!isValid(selectedDate)) return 'Invalid Date';

                                const today = startOfDay(new Date());

                                if (selectedDate < today) {
                                    return 'Must select current date or future date';
                                }

                                const toValue = baseValues?.[`${TITLE_DETAILS}-screening-date.0.to`];

                                if (toValue) {
                                    const toDate = parse(toValue as string, 'yyyy-MM-dd', new Date());

                                    if (isValid(toDate) && isValid(selectedDate)) {
                                        if (toDate < selectedDate) {
                                            return 'Date/Time From cannot be later than Date/Time To';
                                        }
                                    }
                                }

                                return true;
                            }
                        }
                    },
                    {
                        id: 'to',
                        header: 'To',
                        type: 'date2',
                        rule: {
                            baseIds: [`${TITLE_DETAILS}-screening-date.0.from`],
                            required: true,
                            dateLimit: () => {
                                return { minDate: new Date() };
                            },
                            revalidate: [`${TITLE_DETAILS}-screening-date.0.from`],
                            customValidate: ({ currentValue, baseValues }: RuleProps) => {
                                if (!currentValue) return;

                                const selectedDate = parse(currentValue as string, 'yyyy-MM-dd', new Date());
                                if (!isValid(selectedDate)) return 'Invalid Date';

                                const today = startOfDay(new Date());

                                if (selectedDate < today) {
                                    return 'Must select current date or future date';
                                }

                                const fromValue = baseValues?.[`${TITLE_DETAILS}-screening-date.0.from`];

                                if (fromValue) {
                                    const fromDate = parse(fromValue as string, 'yyyy-MM-dd', new Date());

                                    if (isValid(fromDate) && isValid(selectedDate)) {
                                        if (fromDate > selectedDate) {
                                            return 'Date/Time From cannot be later than Date/Time To';
                                        }
                                    }
                                }

                                return true;
                            }
                        }
                    }
                ],
                span: 12
            },
            {
                id: 'screening-venue',
                label: 'Screening Venue',
                type: 'text',
                rule: { required: true }
            }
        ]
    },
    {
        sectionID: SUBTITLES_DETAILS,
        sectionName: 'Subtitles',
        fieldList: [
            {
                id: 'subtitle-1',
                label: 'Subtitle 1',
                apiID: 'IMDA-IRIS-Work-Films-Subtitle',
                type: 'dropdown'
            },
            {
                id: 'subtitle-2',
                label: 'Subtitle 2',
                apiID: 'IMDA-IRIS-Work-Films-Subtitle',
                type: 'dropdown'
            }
        ]
    },
    {
        sectionID: CA_CLASSIFICATION_DETAILS,
        sectionName: 'CA Classification Details',
        fieldList: [
            {
                id: 'ca-rating',
                label: 'CA Rating',
                apiID: 'RCARating',
                type: 'dropdown',
                rule: {
                    required: true
                },
                span: 6
            },
            {
                id: 'ca-decision',
                label: 'CA Decision',
                apiID: 'RCADecision',
                type: 'dropdown',
                span: 6,
                rule: {
                    required: true
                }
            },
            {
                id: 'attachments',
                label: 'CA Assessment Form',
                type: 'file',
                category: 'SupportingDocuments',
                fileTypes: ['.jpeg', '.jpg', '.png', '.bmp', '.mp4', '.mpeg', '.mov', '.pdf', '.xls', '.doc', '.xlsx', '.docx'],
                mimeTypes: [
                    'application/pdf',
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    // 'text/plain',
                    'image/jpeg',
                    'image/jpg',
                    'image/png',
                    // 'image/gif',
                    'image/bmp',
                    'video/quicktime',
                    'video/mp4',
                    'video/mpeg'
                ],
                rule: {
                    required: true
                }
            },
            {
                id: 'ca-consumer-advice',
                label: 'CA Consumer Advice',
                type: 'longText',
                textRows: 4,
                span: 12,
                rule: {
                    baseIds: [`${CA_CLASSIFICATION_DETAILS}-ca-rating`],
                    required: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${CA_CLASSIFICATION_DETAILS}-ca-rating`] === 'PG13_RCA');
                        return result;
                    }
                }
            },
            {
                id: 'ca-comments-remarks',
                label: 'CA Comments/Remarks',
                type: 'longText',
                textRows: 4,
                span: 12
            }
        ]
    }
    // {
    //     sectionID: REMARKS,
    //     sectionName: '',
    //     fieldList: [
    //         {
    //             id: 'remarks',
    //             label: 'Remarks',
    //             type: 'longText',
    //             textRows: 4,
    //             span: 12
    //         },
    //         {
    //             id: 'attachments',
    //             label: 'Attachment Upload',
    //             type: 'file',
    //             category: 'SupportingDocuments',
    //             fileTypes: ['.jpeg', '.jpg', '.png', '.bmp', '.mp4', '.mpeg', '.mov', '.pdf', '.xls', '.doc', '.xlsx', '.docx'],
    //             mimeTypes: [
    //                 'application/pdf',
    //                 'application/vnd.ms-excel',
    //                 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    //                 'application/msword',
    //                 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    //                 // 'text/plain',
    //                 'image/jpeg',
    //                 'image/jpg',
    //                 'image/png',
    //                 // 'image/gif',
    //                 'image/bmp',
    //                 'video/quicktime',
    //                 'video/mp4',
    //                 'video/mpeg'
    //             ],
    //             rule: {
    //                 baseIds: [`${TITLE_DETAILS}-application-form`],
    //                 required: ({ baseValues }: RuleProps) => {
    //                     const result = Boolean(
    //                         baseValues && filmsNonProfit.includes(baseValues[`${TITLE_DETAILS}-application-form`]?.toString())
    //                     );
    //                     return result;
    //                 }
    //             }
    //         },
    //         {
    //             id: 'link-to-attachments',
    //             label: 'Link to Supporting Documents',
    //             type: 'url',
    //             labelNote: 'For files greater than 10MB or in a different file type, you may provide a link. e.g. Dropbox, GoogleDrive.'
    //         }
    //     ]
    // }
];

export default SUBMISSION_OF_CO_CLASSIFIED_FILMS_FOR_EXHIBITION;
